export const cleanersTypes = {
    GET_ACTIVE_CLEANERS: "GET_ACTIVE_CLEANERS",
    CLEAR_ACTIVE_CLEANERS: "CLEAR_ACTIVE_CLEANERS",
}